import { formatBalance } from "../balance";

/**
 *
 * This function generates a Random number from a given range
 *
 * @param minRange - Max value of the range
 * @param maxRange - Min value of the range
 * @returns - return an integer random number
 */
export const generateRandomNumber = (minRange: number, maxRange: number): number => {
  return Math.floor(Math.random() * (maxRange - minRange + 1)) + minRange;
};

// If we pass the amount as '$1000.20' or 'EUR1000.20'
// as string instead of a number,
// use this to get the number back
export const getNumberFromAmount = (amount: string | number) => {
  if (typeof amount === "number") return amount;
  return +amount.replace(/[$a-z]+/i, "").replace(/\s/g, "");
};

export const euclideanDivision = (a: number, b: number): [number, number] => {
  const q = Math.floor(a / b);
  const r = a - b * q;
  return [q, r];
};

export const formatNumberAsString = (value: string) => {
  // \s is used to match any whitespace character
  value = value.replace(/\s/g, "");

  // If the value is an empty string, set the amount to "0"
  if (value === "") {
    return "0";
  }

  const hasMoreDecimalPoints = (value.match(/\./gi) ?? "").length > 1;
  if (hasMoreDecimalPoints && value.endsWith(".")) {
    // amount without the decimal point at the end
    const newAmount = value.substring(0, value.length - 1);
    return newAmount;
  }

  // if value contains "." and value.endsWith("0") => 1.0; 1.10; 1.100
  const decimalZero = value.includes(".") && value.endsWith("0"); // 1.00...; 1.10...
  const decimalPlaces = value.includes(".") ? (value.split(".")[1] || "").length : 0;

  // Prevent 10e-7 error
  if (decimalPlaces > 6) {
    const newAmount = value.split(".");
    newAmount[1] = (newAmount[1] || "").slice(0, 6);
    return newAmount.join(".");
  }

  // If the value ends with ".", append "0" to form a valid floating point number
  const inputNumber = decimalZero ? value : parseFloat(value.endsWith(".") ? value + "0" : value);
  if (!decimalZero && isNaN(inputNumber as number)) return value;

  // If the number is too large, return to avoid setting amount to "Infinity"
  if (inputNumber === Infinity) return value; // TODO: we should use BigNumber instead of float everywhere (to refactor)

  // If the original value ends with ".", add it back after formatting the balance
  return decimalZero ? value : formatBalance(inputNumber as number) + (value.endsWith(".") ? "." : "");
};
